"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ChipComponent_1 = __importDefault(require("../../components/ChipComponent"));
var locale_es_1 = __importDefault(require("../../translations/locale-es"));
var ChipStatusContainer = function (_a) {
    var status = _a.status;
    var statusES = locale_es_1.default['status'][status];
    var color = locale_es_1.default['color'][status];
    return (0, jsx_runtime_1.jsx)(ChipComponent_1.default, { label: statusES, color: color, variant: "outlined" });
};
exports.default = ChipStatusContainer;
